export function capitalize(str: string): string {
  if (str.length === 0) return str
  return str.charAt(0).toUpperCase() + str.substring(1).toLowerCase()
}

export function removeTrailing(symbol: string, str: string): string {
  return str.endsWith(symbol) ? str.slice(0, -1) : str
}

export function binStringToBuf(str: string): Uint8Array {
  const buf = new Uint8Array(str.length)
  return buf.map((_, i) => str.charCodeAt(i))
}

/** regex to insert dashes and enforce only alphanumeric characters */
export function dashifyCode(str: string, codeLength = 19): string {
  return str
    .replace(/[\W_]+/g, '')
    .replace(/\w/g, (c) => c.toUpperCase())
    .replace(/(.{4})/g, '$1-')
    .slice(0, codeLength)
}
